import React from 'react';
import jsbarcode from 'jsbarcode';
import moment from 'moment';
import { Location } from '../../locations/locationsModels';

export interface Props {
  title: string;
  barcode: string;
  onLoad?: Function;
  selectedLocation: Location;
  lineHaulCompanyName?: string;
}

// tslint:disable-next-line:function-name
export default function Barcode({ title, barcode, selectedLocation, lineHaulCompanyName }: Props) {
  const localTime = moment
    .tz(selectedLocation.localeSettings.timezone)
    .format(`${selectedLocation.localeSettings.dateFormat} hh:mm:ss`);

  const barcodeElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  jsbarcode(barcodeElement, barcode, {
    format: 'code128',
    width: 6,
    height: 170,
    fontSize: 40,
  });

  return (
    <div style={{ textAlign: 'center', paddingTop: '50px' }}>
      <p style={{ fontSize: '6rem' }}>
        {title}
      </p>
      <div dangerouslySetInnerHTML={{ __html: barcodeElement.outerHTML }} />
      {lineHaulCompanyName &&
      <p style={{ fontSize: '3rem' }}>
        {`Line Haul Company: ${lineHaulCompanyName}`}
      </p>}
      <p style={{ fontSize: '3rem' }}>
        {`Printed at ${localTime}`}
      </p>
    </div>
  );
}
